import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { H5, SubtitleSecondary } from '../Base';
import Spacing from '../Spacing';

import formatPrice from '../../helpers/formatPrice';

const StyledBox = styled.div`
  padding: ${p => p.theme.spacing(4)} ${p => p.theme.spacing(2)};
  background-color: ${p => p.theme.colours.powderBlue};
  border-radius: 16px;

  ${p => p.theme.media.lg`
    padding: ${p.theme.spacing(4)};
  `};
`;

const StyledItem = styled(SubtitleSecondary)`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${p => p.theme.spacing(2)};

  &:last-child {
    margin-bottom: 0;
  }
`;

const AdditionToFirstBillBox = props => {
  const { items } = props;

  return (
    <StyledBox>
      <Spacing bottom={2}>
        <H5>Addition to your first bill</H5>
      </Spacing>
      {items.map(item => (
        <StyledItem key={item.name}>
          <div>{item.name}</div>
          <div>{formatPrice(item.price)}</div>
        </StyledItem>
      ))}
    </StyledBox>
  );
};

AdditionToFirstBillBox.defaultProps = {
  items: []
};

AdditionToFirstBillBox.propTypes = {
  items: PropTypes.array
};

export default AdditionToFirstBillBox;
